import * as React from 'react'
import { Form } from 'react-bootstrap'
import * as _ from "lodash"

import { useSelector } from 'react-redux'
import Estimate from '../../Estimate/Estimate'
import { isAgreedEstimate } from '../../Estimate/EstimateUtils'
import { JobMode } from '../../../Job'

import { copyObject } from '../../../../../../utils'
import { CompanyT } from '../../../../../../types/Company'
import {  AxiosInstance } from '../../../../../../utils/RequestMethods'
import config from '../../../../../../constants/config'
import { getVariableValue, VariableDocumentT, setValueVariables } from '../../DocumentVariables'
import ButtonLoading from '../../../../../../components/ButtonLoading/ButtonLoading'
import { ClientAgreementT } from '../ClientAgreement'
import { __pick } from '../../../../../../utils'

import ListAgreements from '../../ListAgreements'
import FormValuation from './FormValuation'
import { AgreementT, JobT, ValuationT } from '../../../../../../types/Job'
import { ColoradoClientAgreementObj } from '../../../InitObjectJob'
import { phoneFormat, formatPhoneNumberUS } from '../../../../../../utils'
import { removePrefixUS } from '../../../../../../utils/utilsT'
import { IAppState } from '../../../../../../redux/reducers'
// TODO - DUMMY VARIABLES TO BE FILLED IN FROM BACKEND QUERIES IN FUTURE

const DEDUCTIBLES: Array<ValuationT> = [   // MEMO:  This is an object received from the backend as `deductibles`
  {
    coverage: 7500,
    deductible: 500,
    name: 'Basic',
    premium: 75
  },
  {
    coverage: 15000,
    deductible: 750,
    name: 'Standard',
    premium: 150
  },
  {
    coverage: 30000,
    deductible: 900,
    name: 'Premium',
    premium: 300
  }
]

const paymentAccepted: Array<string> = [
  'Cash',
  'Cashier\'s Check / Money Order / Traveler\'s Check',
  'Personal Check',
  'Credit Card'
]



// END - Dummy variables

interface ColoradoClientAgreementProps {

  company: CompanyT
  job: JobT
  jobOrigin: JobT
  jobMode: JobMode
  nextDocument(): void
  refreshJob(newJob: JobT): void
  saveJob(): Promise<JobT>
  updateJob(key: string, value: any): void
  updateDocument(key: string, value: any): void
}


const liStyle: React.CSSProperties = {
  marginBottom: 20
}


const getAgreementCCA = (job: JobT): Array<AgreementT> => {
  const agreements = job.documents.coloradoClientAgreement && job.documents.coloradoClientAgreement.agreement ? job.documents.coloradoClientAgreement.agreement : []
  return agreements;
}

const isAgreedCCA = (job: JobT, content: any) => {
  const agreements = job.documents.coloradoClientAgreement && job.documents.coloradoClientAgreement.agreement ? job.documents.coloradoClientAgreement.agreement : []
  if (_.isArray(agreements) && agreements.length > 0) {
    const findItem = agreements.find((x) => _.isEqual(x.content, content))
    if (findItem) {
      return true;
    }
  }
  return false;
}


const ColoradoClientAgreement: React.FunctionComponent<ColoradoClientAgreementProps> = ({ company, job, jobOrigin, jobMode, nextDocument, refreshJob, saveJob, updateJob, updateDocument }): JSX.Element => {
  let auth = useSelector((state: IAppState) => state.auth)

  const [currentVariables, setCurrentVariables] = React.useState(ColoradoClientAgreementObj.variables)
  const [isValidFormValuation, setIsValidFormValuation] = React.useState(false);
  const userRole = auth.userData && auth.userData.roles ? auth.userData.roles[0] : []


  React.useEffect(() => {
    // variables Current Document
    let variablesCD = job.documents.coloradoClientAgreement && job.documents.coloradoClientAgreement.variables
    let cloneVariables = copyObject(currentVariables)
    if (variablesCD && !_.isEqual(variablesCD, currentVariables)) {
      cloneVariables = copyObject(variablesCD)

    }
    // check estimate
    let estimateVariables = job.documents.estimate && job.documents.estimate.variables ? job.documents.estimate.variables : []
    const currentEstmaiteV = getVariableByKey('estiamte', cloneVariables);
    if (!_.isEqual(estimateVariables, currentEstmaiteV)) {
      cloneVariables = setValueVariables('estimate', estimateVariables, cloneVariables)
    }

    if (!_.isEqual(variablesCD, cloneVariables)) {

      updateDocumentVariables(copyObject(cloneVariables))
    }
    setCurrentVariables(copyObject(cloneVariables))

  }, [job.documents.coloradoClientAgreement, job.documents.estimate])




  // render estimate
  const estimate = (): JSX.Element => {
    return (
      <div>
        <h3>Estimate</h3>
        <Estimate

          updateDocument={updateDocument}
          job={job}
          jobOrigin={jobOrigin}
          jobMode={jobMode}
          refreshJob={refreshJob}
          saveJob={saveJob}
          nextDocument={nextDocument}
          updateJob={updateJob} />
      </div>
    )
  }


  // getVariableByKey
  const getVariableByKey = (key: string, variables: Array<VariableDocumentT>): any => {
    return getVariableValue(key, variables)
  }

  const saveJobAndIAgree = async (): Promise<string> => {
    try {
      let resSaveJob = await saveJob();
      if (resSaveJob) {
        let res = await saveIAgree();
        if (res && res.data) {
          let data: JobT = res.data
          let msg = 'Client Agreement saved.'
          refreshJob(data)
          return msg;
        }
      }
    } catch (error) {
      //  console.log("error", error)
      throw new Error(error);
    }
  }


  // isChangedCCA
  const isChangedCCA = (): boolean => {
    const currentCCA = job.documents.coloradoClientAgreement && job.documents.coloradoClientAgreement.variables
    const originCCA = jobOrigin.documents.coloradoClientAgreement && jobOrigin.documents.coloradoClientAgreement.variables

    return !_.isEqual(originCCA, currentCCA)
  }


  const isChangeEstimate = (): boolean => {
    let cloneVariables = copyObject(currentVariables)
    let estiamteVariables = job.documents.estimate && job.documents.estimate.variables ? job.documents.estimate.variables : []
    const currentEstmaiteV = getVariableByKey('estiamte', cloneVariables);
    return !_.isEqual(estiamteVariables, currentEstmaiteV)

  }

  const getMailingAddress = () => {
    const { stateMeta } = job.companyInfo

    const samePrimaryPuc = stateMeta && stateMeta.Colorado && stateMeta.Colorado.pucAddress && !stateMeta.Colorado.samePrimaryPuc
    return samePrimaryPuc ? stateMeta.Colorado.pucAddress : job.companyInfo.address
  }
  // render parties
  const parties = (): JSX.Element => {
    const addressState = _.isArray(job.locations) && job.locations[0] && job.locations[0].addressState
    const showMailingAddress = job.jobType != "moving_labor" ? true : false
    return (
      <div>
        <h3>Parties</h3>
        <p>
          This agreement (hereinafter "Agreement") is enacted between the Parties of:
        </p>
        <ol>
          <li key={0} style={liStyle}>
            <strong>{job.companyInfo.name}</strong>, (hereinafter "Company"), with information of
            <ul>
              <li key={0}>Phone: {removePrefixUS(formatPhoneNumberUS(job.companyInfo.phone))}</li>
              <li key={1}>Email: {job.companyInfo.email}</li>
              <li key={2}>Physical Address: {job.companyInfo.address} {job.companyInfo.addressTwo != null && <>Unit {job.companyInfo.addressTwo}</>}</li>
              {showMailingAddress &&
                <>
                  <li key={3}>Mailing Address on file with PUC: {getMailingAddress()}</li>

                  <li key={4}>{job.companyInfo.name} is registered with the Public Utilities Commission of the State of Colorado as a mover. Permit No. {job.companyInfo.stateMeta && job.companyInfo.stateMeta.Colorado && job.companyInfo.stateMeta.Colorado.pucNumber}.</li>
                </>
              }
            </ul>
          </li>
          <li style={liStyle} key={1}>
            <strong>{job.client.firstName} {job.client.lastName}</strong>, (hereinafter "Shipper", "Client"), with information of
            <ul>
              {job.client.phone != '' && <li key={0}>
                Phone: {removePrefixUS(formatPhoneNumberUS(job.client.phone))}
              </li>}
              {job.client.email != '' && <li key={1}>
                Email: {job.client.email}
              </li>}
              {job.client.email != '' && <li key={2}>
                Address: {job.client.address}
                {job.client.address2 != '' && <>Unit: {job.client.address2}</>}
              </li>}
            </ul>
          </li>
        </ol>
      </div>
    )
  }

  // updateCurrentVariables
  const updateCurrentVariables = (key: string, value: any): void => {
    let cloneCurrentVariables = setValueVariables(key, value, currentVariables)
    setCurrentVariables(copyObject(cloneCurrentVariables))
    updateDocumentVariables(cloneCurrentVariables)
  }


  // updateDocumentVariables
  const updateDocumentVariables = (variables: Array<VariableDocumentT>): void => {
    let documentsClone = copyObject(job.documents)
    if (!documentsClone.coloradoClientAgreement) {
      documentsClone = { ...documentsClone, ...{ coloradoClientAgreement: copyObject(ColoradoClientAgreementObj) } }
    } else {
      documentsClone.coloradoClientAgreement.variables = variables;
    }

    updateJob('documents', documentsClone)
  }




  //  saveCCA
  const saveCCA = async (): Promise<string> => {
    try {
      let data = await saveJob();
      if (data) {
        let msg = 'Client Agreement saved.'
        refreshJob(data)
        return msg;
      }
    } catch (error) {
      console.log("error", error)
      throw new Error(error);
    }
  }



  //  saveIAgree
  const saveIAgree = async (): Promise<any> => {
    let url = `${config.url.wpJson}/wp/v2/jobs/${job.id}/agreements`
    let params = {
      name: 'coloradoClientAgreement',
      type: 'agreement',
      clause: 'I Agreed.',
      content: currentVariables

    }
    return await AxiosInstance.post(url, params)
  }

  const isNullClientAgreement = (newJob: JobT): boolean => {
    return newJob.documents.coloradoClientAgreement && newJob.documents.coloradoClientAgreement.variables ? false : true
  }



  const setAgreementByContent = (variables: Array<VariableDocumentT>): void => {

    let documentsClone = copyObject(job.documents)
    let vEsitamte = getVariableByKey('estimate', variables)
    if (vEsitamte) {
      documentsClone.estimate.variables = vEsitamte
    }
    documentsClone.coloradoClientAgreement.variables = variables
    updateJob('documents', documentsClone)
  }



  const renderSectionValuation = (): JSX.Element => {
    return (
      <div>
        <h3>Valuation</h3>
        <ol type="a">
          <li key={0} style={{ fontWeight: "bold" }}>
            <div style={{ fontWeight: 'normal' }}>
              <strong>Released Value Option: </strong>A limit of the mover's liability to the lesser of either
              <ol >
                <li key={0}>A value equal to sixty cents ($0.60) per pound per lost or damaged article</li>
                <li key={1}>the actual value of the lost or damaged article after depreciation for age and wear</li>
              </ol>

            </div>
          </li>
          <li key={1} style={{ fontWeight: "bold" }}>
            <span style={{ fontWeight: 'normal' }}>
              <strong>Full Replacement Cost Option: </strong>A limit of the mover's liability to the
              replacement cost of the entire shipment. This option shall require the shipper to
              declare the value of the shipment. This option may permit the shipper to specify a
              deductible. This option shall provide that the mover is liable for the actual amount
              of loss or damage to each lost or damaged article, up to the full replacement value
              of each lost or damaged article. However, if the shipper declares a value that is
              less than the actual value of the entire shipment, the mover's liability for each lost
              or damaged article will not exceed the proportional value of the article when
              compared to the entire shipment.
            </span>
          </li>

        </ol>

      </div>
    )
  }


  return (
    <div>
      <h1 >Client Agreement</h1>
      {userRole.includes('client') && <p>I,
        {(job.client.firstName == '' || job.client.lastName == '') &&
          <span style={{ display: 'inlineBlock !important' }}>
            <span style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', width: '7em' }}>
              <Form.Control className='input-material' placeholder="First Name" style={{ display: 'inlineBlock !important', width: '7em' }} value={job.client.firstName} />
              <Form.Control className='input-material' placeholder="Last Name" style={{ display: 'inlineBlock !important', width: '7em' }} value={job.client.lastName} />
            </span>
          </span>}
        {!(job.client.firstName == '' || job.client.lastName == '') &&
          <span>{job.client.firstName} {job.client.lastName}</span>}
        , agree to the terms laid out in this Client Agreement.</p>}
      {parties()}
      {estimate()}
      {renderSectionValuation()}
      <FormValuation
        userRole={userRole}
        optionsValuation={getVariableByKey('optionsValuation', currentVariables)}
        onChangeValue={(value) => {
          updateCurrentVariables('optionsValuation', value)
        }}
        validation={(valid) => {
          setIsValidFormValuation(valid)
        }}
      />
      <h3>Signature</h3>
      <p style={{ marginBottom: 10, marginTop: 5 }} >Client agrees to the payment above for the Moving and/or Moving-Related Services estimated in the Estimate above. In the case of damages, Client agrees to make payment in full for all goods and/or services rendered prior to informing a manager or company representative and initiating the Damages Assessment Process. Client agrees to a process of arbitration in the case of a dispute.</p>
      {(userRole.includes('administrator') || userRole.includes('manager')) && isAgreedEstimate(job) && isAgreedCCA(job, currentVariables) && !isChangedCCA() &&
        <p className="text-success text-left">{`Client,  ${job.client.firstName}  ${job.client.lastName}, has agreed to the terms laid out above.`}</p>}

      {/* {isAgreedEstimate(job) && (!isAgreedCCA(job, currentVariables) || isChangedCCA()) &&
                <ButtonLoading
                    disabled={!isChangedCCA()}
                    className="btn-success"
                    onClickFetching={saveCCA}>
                    Save Client Agreement
                 </ButtonLoading>
            } */}

      {jobMode == JobMode.Edit && (userRole.includes('administrator') || userRole.includes('manager')) && !isAgreedCCA(job, currentVariables) &&
        <div>
          <span className="text-danger">Client has not yet agreed.</span>
        </div>
      }
      {jobMode == JobMode.Edit && userRole.includes('client') &&
        <>

          {isAgreedEstimate(job) && !isAgreedCCA(job, currentVariables) && !isValidFormValuation &&
            <div><span style={{ fontWeight: "bold" }} className="text-danger">Agree to the terms above in order to schedule job.</span></div>
          }

          {!isNullClientAgreement(job) &&
            <ButtonLoading
              disabled={!isAgreedEstimate(job) || !isValidFormValuation || isAgreedCCA(job, currentVariables)}
              className="btn-success"
              onClickFetching={saveJobAndIAgree}>
              {isAgreedEstimate(job) && isAgreedCCA(job, currentVariables) ? `Agreed` : `I Agree`}
            </ButtonLoading>
          }
          <a id="anchor-agreement-coloradoClientAgreement" ></a>
        </>
      }

      <ListAgreements
        agreements={getAgreementCCA(job)}
        onClickView={(contant) => {
          setAgreementByContent(contant)
        }}
        currantContent={currentVariables}
      />
    </div>
  )
}

export default ColoradoClientAgreement
